
import { createNamespacedHelpers } from 'vuex'
import { ACTION_UPDATE_POPUP_CLOSED } from '../../../scripts/store/actions/country-redirect'

const { mapGetters, mapActions } = createNamespacedHelpers('countryRedirect')

export default {
  name: 'SghCountryRedirectGenericModal',
  props: {
    storeCountry: {
      type: String,
      default: 'US',
    },
    userCountry: {
      type: String,
      default: 'US',
    },
  },
  computed: {
    ...mapGetters(['countries']),
    getUserCountryLabel() {
      const countryLabel = `country_redirect_green_button_country.${this.userCountry.toLowerCase()}`
      return this.$t(countryLabel)
    },
  },
  methods: {
    ...mapActions({ updatePopupState: ACTION_UPDATE_POPUP_CLOSED }),
    closeCountryRedirectModal() {
      sessionStorage.setItem('GEOPOPUP_CLOSED_BY_USER', true)
      this.updatePopupState()
      this.$parent.toggleOpen()
    },
    getCurrentCountryProperty(propertyName) {
      const storeCountry = this.storeCountry
      const filteredCountries = this.countries.filter(
        country => country.id.toLowerCase() == storeCountry
      )
      return filteredCountries[0][propertyName]
    },
    getGreenButtonCountryProperty(propertyName) {
      const userCountry = this.userCountry && this.userCountry.toLowerCase()
      const filteredCountries = this.countries.filter(
        country => country.id.toLowerCase() == userCountry
      )
      return filteredCountries[0][propertyName]
    },
    getSelectCountries() {
      const userCountry = this.userCountry && this.userCountry.toLowerCase()
      const filteredCountries = this.countries.filter(
        country => country.id.toLowerCase() != userCountry
      )
      return filteredCountries
    },
    showGreenButton() {
      const userCountry = this.userCountry && this.userCountry.toLowerCase()
      const greenButtonCountries = ['au', 'br', 'ca-en','ca-fr','uk', 'nz', 'za']
      return greenButtonCountries.includes(userCountry)
    },
  },
}
